export default __webpack_public_path__ + "img/28.asset.335eb4c2.jpeg";